import { Select, MenuItem } from '@mui/material';

export function LanguageSwitch({ value = 'en', onChange }) {
  return (
    <Select value={value} onChange={onChange} size="small" style={{ minWidth: 80 }}>
      <MenuItem value="en">EN</MenuItem>
      <MenuItem value="te">TE</MenuItem>
      {/* Add more languages as needed */}
    </Select>
  );
}
